import axios from '@/assets/utils/axios'

export function getList(params) {
  return axios.post('/en/user/list ', params)
}
export function handleAdd(params) {
  return axios.post('/en/user/add ', params)
}
export function getUserInfo(params) {
  return axios.post('/en/user/info', params)
}
export function getUser(params) {
  return axios.post('/en/user/get_uinfo', params)
}
